import { useAreaNumUnit } from 'src/utils/hooks/useAreaNumUnit';

export const RoomHeader = (props: any) => {
  const { tableRoom, floorname, measurementSystem } = props;

  const { area, airSpace } = useAreaNumUnit(tableRoom, measurementSystem);
  const tableName = tableRoom.just_unassigned_floor ? '' : '- ' + tableRoom.name;

  return (
    <div className="room-header-container" data-roomid={tableRoom.id}>
      <h3 style={{ fontWeight: 300 }}>
        {floorname} {tableName}
        {area.num ? (
          <span className="quote-room-area">
            {" "}
            [{area.num} {area.unit}
            <sup>2</sup>]
          </span>
        ) : null}
        {airSpace.num ? (
          <span className="quote-room-airspace">
            {" "}
            [{airSpace.num} {airSpace.unit}
            <sup>3</sup>]
          </span>
        ) : null}
      </h3>
    </div>
  );
};
